import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50dd28e2")

_pushScopeId("data-v-50dd28e2")
const _hoisted_1 = {
  key: 0,
  class: "flex justify-start w-full flex-wrap md:flex-wrap md:row-gap-3 px-4 sm:px-5 lg:px-0 md:col-gap-8 my-6"
}
const _hoisted_2 = {
  key: 1,
  class: "checkbox-slider-container"
}
const _hoisted_3 = { class: "checkbox-slider-container-inner relative w-full bg-white lg:flex lg:justify-left lg:items-center max-w-screen-xl" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fadeout-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AppCheckBox = _resolveComponent("AppCheckBox")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.display=='mobile')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterData, (one) => {
            return (_openBlock(), _createBlock(_Fragment, {
              key: one.property
            }, [
              (_ctx.allOption)
                ? (_openBlock(), _createBlock(_component_AppCheckBox, {
                    key: 0,
                    value: _ctx.isAllSelected,
                    label: _ctx.$t('all'),
                    class: "w-1/2 md:w-auto",
                    onOnChange: ($event: any) => (_ctx.emitAll($event, one.property, one[0]?.EntityID.toString()))
                  }, null, 8, ["value", "label", "onOnChange"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(one.data, (val) => {
                return (_openBlock(), _createBlock(_component_AppCheckBox, {
                  key: val.EntityID,
                  value: _ctx.entityIncluded(val.EntityID.toString()),
                  label: val.Caption,
                  class: "w-1/2 md:w-auto",
                  onOnChange: ($event: any) => (_ctx.emitSelected($event, one.property, val.EntityID.toString()))
                }, null, 8, ["value", "label", "onOnChange"]))
              }), 128))
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.display=='desktop')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_swiper, {
              ref: "checkboxSwiper",
              "free-mode": "true",
              "free-mode-sticky": "true",
              "free-mode-momentum-ratio": "0.25",
              "free-mode-velocity-ratio": "0.25",
              "free-mode-minimum-velocity": "0.1",
              "mousewheel-control": "true",
              "mousewheel-sensitivity": "0.5",
              "slide-to-clicked-slide": "false",
              "slides-per-view": "auto",
              "touch-ratio": "0.2",
              class: "checkbox-slider",
              onSwiper: _ctx.onSwiper
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterData, (one) => {
                  return (_openBlock(), _createBlock(_Fragment, {
                    key: one.property
                  }, [
                    _createVNode(_component_swiper_slide, { class: "w-auto md:mr-6" }, {
                      default: _withId(() => [
                        (_ctx.allOption)
                          ? (_openBlock(), _createBlock(_component_AppCheckBox, {
                              key: 0,
                              value: _ctx.isAllSelected,
                              label: _ctx.$t('loc_dropdownlist_all'),
                              class: "w-1/2 md:w-auto",
                              onOnChange: ($event: any) => (_ctx.emitAll($event, one.property, one[0]?.EntityID.toString()))
                            }, null, 8, ["value", "label", "onOnChange"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(one.data, (val) => {
                      return (_openBlock(), _createBlock(_component_swiper_slide, {
                        key: val.EntityID,
                        class: "w-auto md:mr-6"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_AppCheckBox, {
                            value: _ctx.entityIncluded(val.EntityID.toString()),
                            label: val.Caption,
                            class: "w-1/2 md:w-auto",
                            onOnChange: ($event: any) => (_ctx.emitSelected($event, one.property, val.EntityID.toString()))
                          }, null, 8, ["value", "label", "onOnChange"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["onSwiper"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})